import React from "react";
import "./privacypolicy.css";
import bg_waves from "../landingpage/assets/pdvimages/bg_waves.svg";
import bg_down_arrow from "../landingpage/assets/pdvimages/bg_down_arrow.svg";
import spiral_2 from "../landingpage/assets/pdvimages/spiral_2.svg";
import spiral_3 from "../landingpage/assets/pdvimages/spiral_3.svg";
import FooterComponent from "../landingpage/footer/FooterComponent";
import HeaderComponent from "../landingpage/header/HeaderComponent";
import StickyButton from "../../components/generic/stickybutton/StickyButton";

const PrivacyPolicy = () => {

  return (
    <section className="privacy-policy-page ">
       <HeaderComponent />
             <StickyButton />
      <div className="privacy-policy-image">
        <img src={bg_waves} alt="" />
      </div>
      <div className="bg_down_arrow_privacy">
        <img src={bg_down_arrow} alt="" />
      </div>
      <div className="bg_down_arrow_privacy_2">
        <img src={bg_down_arrow} alt="" />
      </div>
      <div className="privacy-spiral privacy-spiral_1">
        <img src={spiral_2} alt="" />
      </div>
      <div className="privacy-spiral privacy-spiral_2">
        <img src={spiral_3} alt="" />
      </div>
      <div className="privacy-spiral privacy-spiral_3">
        <img src={spiral_2} alt="" />
      </div>
      <div className="mb-5 position-relative z-2">
        <h2 className="mt-3 text-center privacy-policy-title mb-5 ">
          Privacy Policy
        </h2>
        <div className="container ">
          <p>
            We value your privacy and take great care to safeguard the data you
            manage via Patient Data Vault (PDV). This privacy statement
            describes the data we gather, how we use it, and the security
            measures we take. Please get in touch with the Patient Data Vault
            team if you have any more questions following your study of this
            policy.
          </p>
          <p>
            <strong>Data Collected & Usage:</strong> <br />
            This section lists data that we may collect based on your usage of
            offered services. This may vary depending on your informed consent
            and interactions with particular solutions. The following aspects of
            these data elements are covered in this section :
            <ul>
              <li>Data - What we collect</li>
              <li>
                Primary Purpose - Why do we need this data? Any additional
                purposes for which we may use this data are covered in the
                subsequent section titled “Secondary Usage Scenarios of Data”.
              </li>
              <li>
                Consent & Opt Out - How is the user informed about collected
                data and the way to opt-out
              </li>
              <li>Additional information</li>
            </ul>
          </p>
          <p>
            <strong>
              Personal Data: <br />
              Data <br />
            </strong>
            While using our Service, we may ask you to provide us with certain
            personally identifiable information that can be used to contact or
            identify you (“Personal Data”). Personally identifiable information
            may include, but is not limited to: 
            <ul>
              <li>
                Account Information: Your Patient Data Vault ID and related
                account details, including email address, physical address,
                devices registered, account status, and age.
              </li>
              <li>
                Device Information. Data from which your device could be
                identified, such as device serial number or a local unique ID,
                or about your device, such as browser type.
              </li>
              <li>
                Contact Information. Data such as name, email address, physical
                address, phone number, or other contact information
              </li>
            </ul>
          </p>
          <p>
            <strong>
              Purpose: <br />
            </strong>
            This data is used for personalizing offered services once a user has
            logged in the features relevant to the role are shown.
          </p>
          <p>
            <strong>
              Consent & Opt-out: <br />
            </strong>
            Users provide this information by explicitly mentioning this as part
            of Signing up or integrating via 3rd party identity providers like
            Google auth, apple account, Enterprise authentication systems like
            active directory, etc. Users can opt-out by requesting deletion of
            an account by sending an email to account
            Service@patientdatavault.com
          </p>
          <p>
            <strong>
              Additional Information: <br />
            </strong>
            In case you have signed up as part of your organization, the account
            is linked with the organization where you are working and is
            delinked within 24 hours once the account is deactivated/deleted by
            your organization.
          </p>
          <p>
            <strong>
              Location Data (Only for Patient Data Vault Application) <br />
              Data
            </strong>
            <br />
            Location consent is only requested for the solution components that
            require real-time location tracking to optimize workflows. If you
            consent, the application will gather your location ONLY during your
            shift time. There is an active indicator in the notification bar
            during this time period of location tracking. This also includes
            changes in the availability of location. All data is transmitted and
            stored securely in the system for audit and generating insights.
          </p>
          <p>
            <strong> Purpose </strong>
            <br />
            This information is shared with the care coordinators of your
            organizations to improve visit scheduling and reduce the time spent
            traveling. Historical location data is used for audit purposes and
            for generating insights for optimizing care delivery. Location
            information may be accessed by your employer as per your
            organization’s policy.
          </p>
          <p>
            <strong> Consent & Opt-out</strong>
            <br />
            The user explicitly provides permission to the application for
            tracking of location. You can any time sign out from the shift in
            case you would not like your location to be tracked. You can also
            enable or disable location services when you use our Service at any
            time by way of your device settings.
          </p>
          <p>
            <strong> Additional Information </strong>
            <br />
            Location access during your shift time may be subject to your
            agreement with your employer and individually provided consent.
            Retention of historical data is governed by your organization's
            policy.
          </p>

          <p>
            <strong>
              Application Usage Data and Diagnostics <br /> Data
            </strong>
            <br /> Your interaction with the solution like app launches, taps,
            clicks, scrolling information, or other information about how you
            are interacting with the app may be stored for generating insight
            and improving the overall experience of the offered service. This
            also includes any diagnostic data like crash logs, performance
            parameters like launch time, and any other data collected for the
            purposes of measuring technical diagnostics that may help in
            identifying the issue faced by you to resolve it. Any sensitive
            information like your location, health, and fitness are not part of
            this data.
          </p>
          <p>
            <strong> Purpose </strong>
            <br />
            This information is used for product personalization, and analytics
            thereby improving the service. This may also be used by customer
            support teams during troubleshooting sessions or walkthroughs.
          </p>
          <p>
            <strong>Consent & Opt-out </strong>
            <br />
            You can opt out of usage analytics from within the application. You
            can obtain a copy of stored data or request a clean wipe of data by
            sending an email to account Service@patientdatavault.com.
          </p>
          <div>
            <p>
              <strong>Secondary Usage Scenarios of Data</strong>
              <br />
              Here are some secondary usage scenarios for the gathered data
              which may be common for all data elements
            </p>
            <ol type="i">
              <li> to provide and maintain our Service;</li>
              <li>to notify you about changes to our Service;</li>
              <li>
                to allow you to participate in interactive features of our
                Service when you choose to do so;
              </li>
              <li>to provide customer support;</li>
              <li>
                to gather analysis or valuable information so that we can
                improve our Service;
              </li>
              <li>to monitor the usage of our Service;</li>
              <li>to detect, prevent, and address technical issues;</li>
              <li>to fulfill any other purpose for which you provide it;</li>
              <li>
                to carry out our obligations and enforce our rights arising from
                any contracts entered into between you and us, including for
                billing and collection;
              </li>
              <li>
                to provide you with notices about your account and/or
                subscription, including expiration and renewal notices, email
                instructions, etc.;
              </li>
              <li>
                in any other way we may describe when you provide the
                information;
              </li>
              <li>for any other purpose with your consent.</li>
            </ol>
          </div>

          <p>
            <strong>Retention of Data </strong>
            <br />
            We will retain your Personal Data only for as long as is necessary
            for the purposes set out in this Privacy Policy. We will retain and
            use your Personal Data to the extent necessary to comply with our
            legal obligations (for example, if we are required to retain your
            data to comply with applicable laws), resolve disputes, and enforce
            our legal agreements and policies.
          </p>
          <p>
            <strong>Transfer of Data </strong>
            <br />
            Your information, including Personal Data, may be transferred to –
            and maintained on – computers located outside of your state,
            province, country or other governmental jurisdiction where the data
            protection laws may differ from those of your jurisdiction.
          </p>
          <p>
            Patient Data Vault will take all the steps reasonably necessary to
            ensure that your data is treated securely and in accordance with
            this Privacy Policy and no transfer of your Personal Data will take
            place to an organization or a country unless there are adequate
            controls in place including the security of your data and other
            personal information.
          </p>
          <p>
            <strong> Disclosure for Law Enforcement. </strong>
            <br />
            Under certain circumstances, we may be required to disclose your
            Personal Data if required to do so by law or in response to valid
            requests by public authorities.
          </p>
          <p>
            <strong> Security of Data </strong>
            <br />
            The security of your data is important to us but remember that no
            method of transmission over the Internet or method of electronic
            storage is 100% secure. While we strive to use commercially
            acceptable means to protect your Personal Data, we cannot guarantee
            its absolute security.
          </p>
          <p>
            <strong>
              Your Data Protection Rights Under General Data Protection
              Regulation (GDPR)
            </strong>
            <br />
            If you are a resident of the European Union (EU) and European
            Economic Area (EEA), you have certain data protection rights,
            covered by GDPR.
          </p>
          <p>
            We aim to take reasonable steps to allow you to correct, amend,
            delete, or limit the use of your Personal Data.
          </p>
          <p>
            In certain circumstances, you have the following data protection
            rights:
            <ol type="i">
              <li>
                The right to access, update or delete the information we have on
                you;
              </li>
              <li>
                The right of rectification. You have the right to have your
                information rectified if that information is inaccurate or
                incomplete;
              </li>
              <li>
                The right to object. You have the right to object to our
                processing of your Personal Data;
              </li>
              <li>
                The right of restriction. You have the right to request that we
                restrict the processing of your personal information;
              </li>
              <li>
                The right to data portability. You have the right to be provided
                with a copy of your Personal Data in a structured,
                machine-readable, and commonly used format;
              </li>
              <li>
                The right to withdraw consent. You also have the right to
                withdraw your consent at any time when we rely on your consent
                to process your personal information;
              </li>
            </ol>
          </p>
          <p>
            Please note that we may ask you to verify your identity before
            responding to such requests. Please note, that we may not be able to
            provide Service without some necessary data.
          </p>
          <p>
            You have the right to complain to a Data Protection Authority about
            our collection and use of your Personal Data. For more information,
            please contact your local data protection authority in the European
            Economic Area (EEA).
          </p>
          <p>
            <strong>
              Your Data Protection Rights under the California Privacy
              Protection Act (CalOPPA)
            </strong>
          </p>
          <p>
            CalOPPA is the first state law in the nation to require commercial
            websites and online services to post a privacy policy. The law’s
            reach stretches well beyond California to require a person or
            company in the United States (and conceivable the world) that
            operates websites collecting personally identifiable information
            from California consumers to post a conspicuous privacy policy on
            its website stating exactly the information being collected and
            those individuals with whom it is being shared and to comply with
            this policy.
          </p>
          <p>
            According to CalOPPA, we agree to the following:
            <ol>
              <li>users can visit our site anonymously;</li>
              <li>
                our Privacy Policy link includes the word “Privacy”, and can
                easily be found on the homepage of our website;
              </li>
              <li>
                users will be notified of any privacy policy changes on our
                Privacy Policy Page;
              </li>
            </ol>
          </p>
          <p>Our Policy on “Do Not Track” Signals:</p>
          <p>
            We honor Do Not Track signals and do not track, plant cookies, or
            use advertising when a Do Not Track browser mechanism is in place.
            Do Not Track is a preference you can set in your web browser to
            inform websites that you do not want to be tracked.
          </p>
          <p>
            You can enable or disable Do Not Track by visiting the Preferences
            or Settings page of your web browser.
          </p>
          <p>
            <strong>
              Your Data Protection Rights under the California Consumer Privacy
              Act (CCPA)
            </strong>
          </p>
          <p>
            If you are a California resident, you are entitled to learn what
            data we collect about you, ask to delete your data, and not to sell
            (share) it. To exercise your data protection rights, you can make
            certain requests and ask us:
            <ol type="i">
              <li>
                <strong>
                  What personal information do we have about you? If you make
                  this request, we will return to you:
                </strong>
                <ol type="a">
                  <li>
                    The categories of personal information we have collected
                    about you.
                  </li>
                  <li>
                    The categories of sources from which we collect your
                    personal information.
                  </li>
                  <li>
                    The business or commercial purpose for collecting or selling
                    your personal information.
                  </li>
                  <li>
                    The categories of third parties with whom we share personal
                    information.
                  </li>
                  <li>
                    The specific pieces of personal information we have
                    collected about you.
                  </li>
                  <li>
                    A list of categories of personal information that we have
                    sold, along with the category of any other company we sold
                    it to. If we have not sold your personal information, we
                    will inform you of that fact.
                  </li>
                  <li>
                    A list of categories of personal information that we have
                    disclosed for a business purpose, along with the category of
                    any other company we shared it with.
                  </li>
                </ol>
                <p>
                  Please note, that you are entitled to ask us to provide you
                  with this information up to two times in a rolling
                  twelve-month period. When you make this request, the
                  information provided may be limited to the personal
                  information we collected about you in the previous 12 months.
                </p>
              </li>
              <li>
                <strong>
                  To delete your personal information. - If you make this
                  request, we will delete the personal information we hold about
                  you as of the date of your request from our records and direct
                  any service providers to do the same. In some cases, deletion
                  may be accomplished through de-identification of the
                  information. If you choose to delete your personal
                  information, you may not be able to use certain functions that
                  require your personal information to operate.
                </strong>
              </li>
              <li>
                <strong>
                  To stop selling your personal information. - We don’t sell or
                  rent your personal information to any third parties for any
                  purpose. We do not sell your personal information for monetary
                  consideration. However, under some circumstances, a transfer
                  of personal information to a third party, or within our family
                  of companies, without monetary consideration may be considered
                  a “sale” under California law. You are the only owner of your
                  Personal Data and can request disclosure or deletion at any
                  time.
                </strong>
              </li>
            </ol>
          </p>
          <p>
            If you submit a request to stop selling your personal information,
            we will stop making such transfers. <br />
            Please note, if you ask us to delete or stop selling your data, it
            may impact your experience with us, and you may not be able to
            participate in certain programs or membership services that require
            the usage of your personal information to function. But in no
            circumstances, we will discriminate against you for exercising your
            rights. <br />
            To exercise your California data protection rights described above,
            please send your request(s) by email:
            accountService@patinetdatavault.com <br />
            Your data protection rights, described above, are covered by the
            CCPA, short for the California Consumer Privacy Act. To find out
            more, visit the official California Legislative Information website.
            The CCPA took effect on 01/01/2020.
          </p>
          <p>
            <strong>Children’s Privacy </strong> <br /> Our Services are not
            intended for use by children under the age of 18 (“Child”
            or“Children”). <br />
            We do not knowingly collect personally identifiable information from
            children under 18. If you become aware that a Child has provided us
            with Personal Data, please contact us. If we become aware that we
            have collected Personal Data from Children without verification of
            parental consent, we take steps to remove that information from our
            servers.
          </p>
          <p>
            <strong>
              {" "}
              Changes to This Privacy Policy <br />{" "}
            </strong>
            We may update our Privacy Policy from time to time. We will notify
            you of any changes by posting the new Privacy Policy on this page.
          </p>
          <p>
            We will let you know via email and/or a prominent notice on our
            Service, prior to the change becoming effective and update the
            “effective date” at the top of this Privacy Policy.
          </p>
          <p>
            You are advised to review this Privacy Policy periodically for any
            changes. Changes to this Privacy Policy are effective when they are
            posted on this page.
          </p>
        </div>
      </div>
      <FooterComponent />
    </section>
  );
};

export default PrivacyPolicy;
